<div class="select__item" #item><ng-content></ng-content></div>
